<!-- <p>Start is : {{browseService.surveyStart}}</p>
<p>End is : {{browseService.surveyEnd}}</p> -->
<!-- <p>browse-survey works!</p> -->

<div class="survey-container">

    <iframe width="100%" height="100%" frameBorder="0" [(src)]="urlSafe" #surveyIfrale (load)="onUrlChange();"></iframe>
    <!-- <iframe width="100%" height="100%" frameBorder="0" [(src)]="urlSafe" #surveyIfrale (load)="alert()"></iframe> -->
    <!-- <iframe width="100%" height="100%" frameBorder="0" [src]="urlSafe" #surveyIfrale ></iframe> -->
</div>